import { createAction } from 'redux-actions';

export const loadOrganizationsList = createAction('LOAD_ORGANIZATIONS_LIST');
export const loadedOrganizationsList = createAction('LOADED_ORGANIZATIONS_LIST');
export const unloadOrganizationsList = createAction('UNLOAD_ORGANIZATIONS_LIST');
